import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "playbookfigure--three-b",
  "use": "playbookfigure--three-b-usage",
  "viewBox": "0 0 300 200",
  "content": "<symbol viewBox=\"0 0 300 200\" id=\"playbookfigure--three-b\">\n  <path class=\"PlaybookFigure-colorOne\" d=\"M25 0L0 50h25L0 100h25L0 150h25L0 200h50l25-50H50l25-50H50l25-50H50L75 0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol